module.exports = __webpack_public_path__ + "static/excluding7-ad3ce7f4bdcb63d6a5a0ca78748d31c0.png";